import type { Version } from './api.ts';

/**
 * THE ONE CONTROL IN THIS PAGE THAT CHANGES WHAT EVERY LABELER IS HANDED NEXT,
 * and there is no undo anywhere behind it.
 *
 * So it is a confirm step, and the confirm NAMES THE VERSION rather than saying
 * "this one" — a mis-click on the wrong column is then caught by reading
 * instead of by undoing.
 *
 * IT LIVES IN ITS OWN FILE because two screens promote now: the side-by-side
 * comparison and the player. The API call was already shared (`api.promoteVersion`);
 * these words were not, and two copies of a sentence about an irreversible act
 * is exactly the pair that drifts — one of them gets edited, the other keeps
 * promising something that is no longer true.
 */
export function ConfirmPromote({
  version,
  onCancel,
  onConfirm,
}: {
  version: Version;
  onCancel: () => void;
  onConfirm: () => void;
}): JSX.Element {
  return (
    <div className="modal-backdrop" role="presentation" onClick={onCancel}>
      <div
        className="modal"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="confirm-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="confirm-title">Make this the truth so far?</h2>
        <p className="hint">
          {/*
            * THE LABEL ALREADY NAMES THE AUTHOR for anything a person made —
            * the server writes it as "by Amjad Alashqar" — so appending the
            * author here produced "by End-to-end run by End-to-end run". The
            * machine's own version is labelled "AI first run", which needs no
            * author either. The label is the whole name.
            */}
          <strong>{version.label}</strong> — {version.segmentCount} clips — becomes the arrangement
          this recording answers with. The work queue follows the truth, so everyone is handed clips
          from this version from now on. The one it replaces keeps its rows, its history and its
          votes.
        </p>
        <div className="btn-row">
          <button className="btn-quiet" type="button" onClick={onCancel}>
            Cancel
          </button>
          <button className="btn-primary" type="button" style={{ width: 'auto' }} onClick={onConfirm}>
            Select as perfect
          </button>
        </div>
      </div>
    </div>
  );
}
